import { getFeatureConfig } from '@luna/feature-config';
import { getEnv } from '@luna/env';

import { isProdEnvironment } from './EnvironmentService';

export enum ALEX_PROXY_MODE {
    REMOTE = 'remote',
    LOCAL = 'local',
    OFF = 'off',
}

export const ALEX_PROXY_MODE_URL_PARAM = 'alexProxyMode';

export function getAlexProxyMode(): ALEX_PROXY_MODE {
    const search = new URLSearchParams(window.location.search);
    const alexProxyMode = search.get(ALEX_PROXY_MODE_URL_PARAM);

    if (alexProxyMode === ALEX_PROXY_MODE.REMOTE) {
        return ALEX_PROXY_MODE.REMOTE;
    }

    if (alexProxyMode === ALEX_PROXY_MODE.LOCAL) {
        return ALEX_PROXY_MODE.LOCAL;
    }

    return ALEX_PROXY_MODE.OFF;
}

export function isAlexProxyActive(): boolean {
    return getAlexProxyMode() !== ALEX_PROXY_MODE.OFF && !isProdEnvironment();
}

export function getAlexProxyUrl(): string {
    const alexProxyUrlMapKey =
        getFeatureConfig((config) => config.alexProxyVersion) === 'v2'
            ? 'alexProxy2Url'
            : 'alexProxyUrl';
    const mode = getAlexProxyMode();

    if (!getEnv()[alexProxyUrlMapKey] || mode === ALEX_PROXY_MODE.OFF) {
        return '';
    }

    return getEnv()[alexProxyUrlMapKey]![mode] ?? '';
}

export function addAlexProxyUrl(url: string): string {
    return `${getAlexProxyUrl()}${url}`;
}
